<template>
    <div>
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="buscar"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table style="table-layout: fixed"
                :headers="lista.headers"
                :items="resultados"
                :rows-per-page-items="tableProps.rows"
                :no-data-text="tableProps.noData"
                :no-results-text="tableProps.noResults"
                :rows-per-page-text="tableProps.rowsText"
                class="elevation-1"
                :search="buscar"
            >

                <template slot="items" slot-scope="props">
                    <td style="padding:2px;" class="text-xs-center">
                        <v-menu 
                            transition="scale-transition"
                            origin="left top"
                            bottom
                            right
                            slot="activator"
                        >
                            <v-btn class="ma-0" icon slot="activator">
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list class="app-card-action">
                                <v-list-tile 
                                    @click="mostrarDetalles(props.item._id)">
                                    <i class="fa fa-address-card blue--text mr-2 fs-14"></i>
                                    <span>Detalles</span>
                                </v-list-tile>
                                <v-list-tile 
                                    v-if="puedeModificarRegistro"
                                    @click="modificarRegistroDialog(props.item._id,props.item.registro,props.item.hora,props.item.entrada)">
                                    <i class="fa fa-clock blue--text mr-2 fs-14"></i>
                                    <span>Modificar registro</span>
                                </v-list-tile>
                                <v-list-tile 
                                    v-if="puedeAsignarLocalidad && props.item.registro"
                                    @click="localidadDialog(props.item._id,props.item.localidad)">
                                    <i class="fa fa-building blue--text mr-2 fs-14"></i>
                                    <span>Asignar localidad</span>
                                </v-list-tile>
                                <v-list-tile
                                    v-if="puedeAsignarObs"
                                    @click="modificarObsDialog(props.item._id,props.item.observaciones)">
                                    <i class="fa fa-edit blue--text mr-2 fs-14"></i>
                                    <span>Observaciones</span>
                                </v-list-tile>
                                <v-list-tile v-if="puedeAsignarVacaciones && props.item.status != 'Vacaciones'" @click="asignaVacaciones(props.item._id)">
                                    <i class="fa fa-images blue--text mr-2 fs-14"></i>
                                    <span>Marcar como vacaciones</span>
                                </v-list-tile>
                                <v-list-tile v-if="puedeAsignarVacaciones && props.item.status == 'Vacaciones'" @click="asignaVacaciones(props.item._id)">
                                    <i class="fa fa-images red--text mr-2 fs-14"></i>
                                    <span>Desmarcar como vacaciones</span>
                                </v-list-tile>
                                <v-list-tile @click="eliminarDialog(props.item._id)">
                                    <i class="fa fa-times red--text mr-2 fs-14"></i>
                                    <span>Eliminar asistencia</span>
                                </v-list-tile>
                            </v-list>
                        </v-menu>

                    </td>
                    <td style="padding:2px;" class="text-xs-center">
                        <v-badge v-if="props.item.observaciones" overlap color="orange">
                            <template v-slot:badge>
                                <span><i class="fa fa-info"></i></span>
                            </template>
                            <v-avatar size="30" color="light-blue darken-2">
                                <img v-if="props.item.imagen" :src="`data:image/png;base64,${props.item.imagen}`" />
                                <v-icon v-else dark>account_circle</v-icon>
                            </v-avatar>
                        </v-badge>
                        <div v-else>
                            <v-avatar size="30" color="light-blue darken-2">
                                <img v-if="props.item.imagen" :src="`data:image/png;base64,${props.item.imagen}`" />
                                <v-icon v-else dark>account_circle</v-icon>
                            </v-avatar>
                        </div>
                    </td>
                    <td style="padding:2px;" class="text-xs-center">
                        <div style="width: 90px">
                            {{ props.item.codigo }}
                        </div>
                    </td>
                    <td style="padding:2px;" class="text-xs-left">
                        <div style="width: 200px">
                            {{ props.item.nombre }}
                        </div>
                    </td>
                    <td class="text-xs-left">{{ props.item.fecha }}</td>

                    <td style="padding:2px;" v-if="props.item.entrada" class="text-xs-left"><i class="fa fa-sign-in-alt green--text mr-2 fs-14"></i>Entrada</td>
                    <td style="padding:2px;" v-else class="text-xs-left"><i class="fa fa-sign-out-alt red--text mr-2 fs-14"></i>Salida</td>

                    <td style="padding:2px;" class="text-xs-left">{{ props.item.hora }}</td>
                    <td style="padding:2px;" class="text-xs-left">{{ props.item.registro }}</td>
                    <td style="padding:2px;" class="text-xs-left">
                        <v-chip :color="statusColor(props.item.status)" small text-color="white">{{ props.item.status }}</v-chip>
                    </td>
                    
                    <!-- <td style="padding:2px;" class="text-xs-left">{{ props.item.localidad }}</td>
                    <td style="padding:2px;" class="text-xs-left">{{ props.item.observaciones }}</td> -->
                </template>
            </v-data-table>
        </v-card>



        <v-dialog v-model="obs.mostrar" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">Observaciones</v-card-title>
                <v-card-text>
                    <v-textarea
                        label="Observaciones"
                        v-model="obs.texto"
                        rows="5"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="normal" @click="obs.mostrar = false">Cancelar</v-btn>
                <v-btn color="primary" @click="modificarObs()">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="eliminar.mostrar" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">Zona protegida</v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="eliminar.password"
                        label="Contraseña"
                        type="password"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="normal" @click="eliminar.mostrar = false">Cancelar</v-btn>
                <v-btn color="primary" @click="eliminarRegistro()">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="registro.mostrar" persistent max-width="320">
            <v-card>
                <v-card-title class="headline">Registro</v-card-title>
                <v-card-text>
                    <v-time-picker 
                        v-model="registro.hora"
                        format="24hr"
                        :min="registro.min"
                        :max="registro.max">
                    </v-time-picker>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="normal" @click="registro.mostrar = false">Cancelar</v-btn>
                <v-btn color="primary" @click="modificarRegistro()">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="detalles.mostrar" max-width="300">
            <v-card>
                <v-card-title class="headline">Detalles</v-card-title>
                <v-card-text>
                    <p class="text-xs-center">
                        <v-avatar size="200" color="light-blue darken-2" tile>
                            <img v-if="detalles.datos.imagen" :src="`data:image/png;base64,${detalles.datos.imagen}`" />
                            <v-icon v-else dark size="180">account_circle</v-icon>
                        </v-avatar>
                    </p>
                </v-card-text>
                <v-card-text>
                    <p class="text-xs-center">
                        <b>{{detalles.datos.codigo}} - {{detalles.datos.nombre}}</b>
                    </p>
                    <p class="text-xs-center">
                        <b>{{detalles.datos.fecha}}</b>
                    </p>
                    <p v-if="detalles.datos.entrada" class="text-xs-left">
                        <i class="fa fa-sign-in-alt green--text mr-2 fs-14"></i> Entrada:
                        {{detalles.datos.hora}}
                    </p>
                    <p v-else class="text-xs-left">
                        <i class="fa fa-sign-out-alt red--text mr-2 fs-14"></i> Salida:
                        {{detalles.datos.hora}}
                    </p>
                    <p v-if="detalles.datos.registro" class="text-xs-left">
                        <i class="fa fa-clock blue--text mr-2 fs-14"></i> Registro:
                        {{detalles.datos.registro}}
                    </p>
                    <p class="text-xs-left">
                        <i :class="'fa fa-square '+statusColorSingle(detalles.datos.status)+'--text mr-2 fs-14'"></i> Status:
                        {{ detalles.datos.status }}
                    </p>
                    <p v-if="detalles.datos.localidad" class="text-xs-left">
                        <i class="fa fa-building blue--text mr-2 fs-14"></i> Localidad:
                        {{ detalles.datos.localidad }}
                    </p>
                    <p v-if="detalles.datos.observaciones" class="text-xs-left">
                        <i class="fa fa-info-circle blue--text mr-2 fs-14"></i> Observaciones:
                        {{ detalles.datos.observaciones }}
                    </p>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="normal" small @click="detalles.mostrar = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

         <v-dialog v-model="localidad.mostrar" max-width="400">
            <v-card>
                <v-card-title class="headline">Asignar localidad</v-card-title>
                <v-card-text>
                    <v-autocomplete
                        v-model="localidad.id"
                        :items="localidades"
                        label="Localidad"
                        persistent-hint
                        item-text="nombre"
                        item-value="_id"
                    >
                    </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="normal" @click="localidad.mostrar = false">Cancelar</v-btn>
                <v-btn color="primary" @click="modificarLocalidad()">Guardar</v-btn>
                </v-card-actions>
            </v-card>
         </v-dialog>


    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment-timezone'

export default {
    name: 'Resultados',
    props:['resultados','localidades'],
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "tableProps",
            "role",
            "permisos"
        ]),
        puedeAsignarObs(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 194) >= 0 ? true : false;
        },
        puedeAsignarVacaciones(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 195) >= 0 ? true : false;
        },
        puedeModificarRegistro(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 193) >= 0 ? true : false;
        },
        puedeAsignarLocalidad(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 199) >= 0 ? true : false;
        },
    },
    data() {
        return {
            enviando:false,
            buscar:'',
			lista:{
				headers:[
                    { text: '', value: 'options', sortable: false },
                    { text: '', value: 'foto', sortable: false },
                    { text: 'Código', value: 'codigo'},
                    { text: 'Nombre', value: 'nombre' },
                    { text: 'Fecha', value: 'fecha' },
                    { text: 'Ent/Sal', value: 'entrada' },
                    { text: 'Hora', value: 'hora' },
                    { text: 'Registro', value: 'registro' },
                    { text: 'Status', value: 'status' }
                ],
                data:[]
            },
            obs:{
                mostrar: false,
                _id: null,
                texto: null
            },
            eliminar:{
                mostrar: false,
                _id: null,
                password: null    
            },
            registro:{
                mostrar: false,
                min: null,
                max: null,
                hora: null
            },
            detalles:{
                mostrar: false,
                datos: {}
            },
            localidad:{
                mostrar: false,
                id: null,
                asistencia:null
            }
        }
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        statusColor(status){
            if( status == 'Pendiente') return 'grey';
            if( status == 'Asistencia') return 'green darken-1';
            if( status == 'Vacaciones') return 'blue darken-1';
            if( status == 'Retardo') return 'orange darken-1';
            if( status == 'Falta') return 'red darken-1';
        },
        statusColorSingle(status){
            if( status == 'Pendiente') return 'grey';
            if( status == 'Asistencia') return 'green';
            if( status == 'Vacaciones') return 'blue';
            if( status == 'Retardo') return 'orange';
            if( status == 'Falta') return 'red';
        },
        modificarObsDialog(id,texto){
            this.obs._id = id;
            this.obs.texto = texto;
            this.obs.mostrar = true;
        },
        modificarObs(){
            this.enviandoStart();
            axios.put(this.httpURL+'/asistencias/observaciones/'+this.obs._id,
                {texto: this.obs.texto},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    let index = this.resultados.findIndex(x=>x._id == this.obs._id);
                    this.resultados[index].observaciones = this.obs.texto;
                    this.obs.mostrar = false;
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        asignaVacaciones(id){
            this.enviandoStart();
            axios.put(this.httpURL+'/asistencias/vacaciones/'+id, {},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    let index = this.resultados.findIndex(x=>x._id == id);
                    this.resultados[index].status = res.data.statusText;
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
            
        },
        modificarRegistroDialog(id,registro,hora,entrada){
            this.enviandoStart();
            axios.get(this.httpURL+'/asistencias/tolerancia/'+id,{headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    let tolerancia = res.data.tolerancia;
                    let horaTime = moment(hora,'HH:mm');
                    this.registro.hora = registro ? registro : hora;
                    if( entrada){
                        horaTime.add((tolerancia.entrada.previo*-1),'minutes');
                        this.registro.min = horaTime.format('HH:mm');
                        horaTime.add(tolerancia.entrada.previo+tolerancia.entrada.posterior+tolerancia.entrada.retardo,'minutes');
                        this.registro.max = horaTime.format('HH:mm');
                    }else{
                        horaTime.add((tolerancia.salida.previo*-1),'minutes');
                        this.registro.min = horaTime.format('HH:mm');
                        horaTime.add(tolerancia.salida.previo+tolerancia.salida.posterior,'minutes');
                        this.registro.max = horaTime.format('HH:mm');
                    }
                    this.registro.mostrar = true;
                    this.registro.id = id;
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        modificarRegistro(){
            this.enviandoStart();
            axios.put(this.httpURL+'/asistencias/registro/'+this.registro.id, {registro:this.registro.hora},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    let index = this.resultados.findIndex(x=>x._id == this.registro.id);
                    this.resultados[index].registro = this.registro.hora;
                    this.resultados[index].status = res.data.statusText;
                    this.enviandoStop();
                    this.registro.mostrar = false;
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        mostrarDetalles(id){
            this.detalles.datos = this.resultados.find(x=>x._id == id);
            this.detalles.mostrar = true;
        },
        localidadDialog(asistencia,localidad){
            this.localidad.id = localidad;
            this.localidad.asistencia = asistencia;
            this.localidad.mostrar = true;
        },
        modificarLocalidad(){
            this.enviandoStart();
            axios.put(this.httpURL+'/asistencias/localidad/'+this.localidad.asistencia, {localidad:this.localidad.id},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    let index = this.resultados.findIndex(x=>x._id == this.localidad.asistencia);
                    this.resultados[index].localidad = res.data.localidad;
                    this.resultados[index].direccion = res.data.direccion;
                    this.enviandoStop();
                    this.localidad.mostrar = false;
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        eliminarDialog(id){
            this.eliminar.mostrar = true;
            this.eliminar.password = '';
            this.eliminar._id = id;
        },
        eliminarRegistro(){
            this.enviandoStart();
            axios.delete(this.httpURL+'/asistencias/'+this.eliminar._id,
                {
                    data: {password: this.eliminar.password},
                    headers:{token: this.sessionToken}
                })
                .then(res => {
                    // console.log(res);
                    this.enviandoStop();
                    if( res.data.ok ){
                        let index = this.resultados.findIndex(x=>x._id == this.eliminar._id);
                        this.resultados.splice(index,1)
                        this.eliminar.mostrar = false;
                        this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                    }else{
                        this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: res.data.mensaje});
                    }
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        }
    }
}
</script>